const ORDER_BY = {
	DATE_DESC: 'orderBy=createDateTime&orderDirection=desc',
	DATE_ASC: 'orderBy=createDateTime&orderDirection=asc',
	PRICE_DESC: 'orderBy=priceHuf&orderDirection=desc',
	PRICE_ASC: 'orderBy=priceHuf&orderDirection=asc'
};
const MAX_SAVED_SEARCH_COUNT = 30;
// const PAGE_SIZE = 10;
export const RealEstateSearchResultListComponent = {
	bindings: {
		realEstateList: '<',
		realEstateSearchResponse: '<',
		showResultListItems: '<',
		searchPagerOrOrder: '&',
		formOrder: '<',
		savedSearchCount: '<',
		existedSearch: '<',
		factoring: '<',
		modelData: '<',
		showMap: '<',
		showList: '<',
		viewChange: '&',
		filtersShow: '&'
	},
	templateUrl: 'real-estate-search-result-list.html',
	controller: class RealEstateSearchResultListComponent {
		constructor($mdDialog, SearchesService, $rootScope, loginService, SearchService, $timeout) {
			'ngInject';
			this.size = 2;
			this.currentPage = 0;
			this.ORDER_BY = ORDER_BY;
			this.order = this.ORDER_BY.DATE_DESC;
			this.$mdDialog = $mdDialog;
			this.model = {};
			this.searchesService = SearchesService;
			this.searchService = SearchService;
			this.$rootScope = $rootScope;
			this.$timeout = $timeout;
			this.loginService = loginService;
			this.MAX_SAVED_SEARCH_COUNT = MAX_SAVED_SEARCH_COUNT;
		}

		$onInit() {
			this.isLoggedIn = this.$rootScope.isLoggedIn;
		}

		$onChanges(changes) {
			if (changes.realEstateList) {
				this.list = angular.copy(this.realEstateList);
			}
			if (changes.realEstateSearchResponse && this.realEstateSearchResponse) {
				this.responseData = angular.copy(this.realEstateSearchResponse);
				// this.totalPages = Math.ceil(this.responseData.content.length / PAGE_SIZE);
				this.size = this.responseData.size;
				this.currentPage = this.responseData.number;
			}
			if (changes.showResultListItems) {
				this.showRealEstateSearchResultItems = angular.copy(this.showResultListItems);
			}
			if (changes.formOrder) {
				if (this.formOrder) {
					this.order = Array.isArray(this.formOrder) ? angular.copy(this.formOrder[0]) : angular.copy(this.formOrder);
				}
			}
			if (changes.savedSearchCount) {
				if (Number.isInteger(this.savedSearchCount)) {
					this.searchCount = angular.copy(this.savedSearchCount);
				}
			}
			if (changes.existedSearch) {
				if (this.existedSearch && Object.keys(this.existedSearch).length) {
					this.alreadyExistingSearchName = angular.copy(this.existedSearch.name);
				} else {
					this.alreadyExistingSearchName = '';
				}
			}
			if (changes.factoring) {
				this.isOwnedByFactoring = angular.copy(this.factoring);
			}
			if (changes.modelData) {
				this.allFormData = angular.copy(this.modelData);
			}
			if (changes.showMap) {
				this.mapView = this.showMap;
				let elm = angular.element('#header');
				if(this.mapView) {
					elm.addClass('header--is-fixed');
				} else {
					if(elm.hasClass('header--is-fixed')) {
						elm.removeClass('header--is-fixed');
					}
				}
			}
			if (changes.showList) {
				this.listView = this.showList;
			}
		}

		searchByOrder() {
			this.searchPagerOrOrder({
				$event: {
					order: this.order,
					paging: {		// setClientSidePageData() {
		// 	this.showRealEstateSearchResultItems = false;
		// 	this.list = angular.copy(this.realEstateList.slice(this.currentPage * PAGE_SIZE, (this.currentPage + 1) * PAGE_SIZE));
		// 	this.$timeout(()=>{
		// 		this.showRealEstateSearchResultItems = true;
		// 	})

		// }
						page: 0,
						pageSize: this.size
					}
				}
			});
		}

		loadPage(event) {
			this.pager(event.pageTo, this.size);
		}

		pager(page, size) {
			let params = {
				page: page,
				pageSize: size
			};
			// this.currentPage = page;
			// this.setClientSidePageData();
			this.searchPagerOrOrder({
				$event: {
					order: this.order,
					paging: params
				}
			});
		}

		openSaveSearch() {
			this.$mdDialog.show({
				templateUrl: 'saved-search-add-name.html',
				clickOutsideToClose: true,
				controller:()=>this,
				controllerAs: '$ctrl'
			}).finally(() => {
				this.closeSaveSearch();
			});
		}

		closeSaveSearch(type) {
			this.model.name = '';
			this.notifications = {};
			this.$mdDialog.hide();
		}

		saveSearch() {
			let url = window.location.href;
			let urlArr = url.split('/');
			let tmp = [];
			for(let i = 0; i < urlArr.length; i++) {
				if (!/darab=\d+$/.test(urlArr[i]) && !/oldal=\d+$/.test(urlArr[i]) ) {
					tmp.push(urlArr[i]);
				}
			}
			this.model.url = tmp.join('/');

			this.model.searchParams = this.queryStringToJSON(this.searchService.transformFormData(this.allFormData));
			delete this.model.searchParams.page;
			delete this.model.searchParams.pageSize;

			this.model.searchParams = JSON.stringify(this.model.searchParams);

			this.searchesService.checkExistance({url: this.model.url}).then(() => {
				// a menteni kívánt keresés létezik
				this.notifications = {
					message: 'A menteni kívánt keresés már létezik.'
				};
			}).catch(() => {
				// nem létező keresés, mentjük
				this.searchesService.saveSearch(this.model).then(() => {
					// mentve
					this.notifications = {
						message: 'Sikeres mentés.'
					};
					this.alreadyExistingSearchName = this.model.name;
				}).catch(() => {
					this.notifications = {
						message: 'Sikertelen mentés.'
					};
				});
			});
		}

		queryStringToJSON(url) {
			if (url.length >= 2) {
				if (url.startsWith("?&")) {
					url = url.substring(1);
				}
			} else {
				return "{}";
			}
			let pairs = url.slice(1).split('&');

			let result = {};
			for (let i = 0; i < pairs.length; i++) {
				let pair = pairs[i];
				pair = pair.split('=');
				result[pair[0]] = decodeURIComponent(pair[1] || '');
			}
			return result;
		}

		filtersShow() {
			this.showFilters();
		}

		change(list, map) {
			this.viewChange({
				$event: {
					showList: list,
					showMap: map
				}
			});
		}
	}
};
